import { useState, useCallback } from 'react';

export const useLoading = (defaultState = false) => {
  const [isLoading, setIsLoading] = useState(defaultState);

  const withLoading = useCallback(async (fn: () => Promise<any>) => {
    try {
      setIsLoading(true);
      // Simulate minimum loading time of 500ms for better UX
      await Promise.all([
        fn(),
        new Promise(resolve => setTimeout(resolve, 500))
      ]);
    } finally {
      setIsLoading(false);
    }
  }, []);

  return { isLoading, setIsLoading, withLoading };
};